import { Button } from "#components/v2/Button";
import { SupportMenu } from "#components/v2/SupportMenu";
import { SidebarSimpleIcon, FilesIcon } from "#icons";
import { cn } from "#utils";
import { Tooltip } from "#components/v2/Tooltip";

import { BreadcrumbNavList, type BreadcrumbTab } from "./BreadcrumbNavList";

export interface Breadcrumbs {
  label: string;
  tabs?: BreadcrumbTab[];
}

export interface BreadcrumbHeaderProps {
  pathname: string;
  breadcrumbs: BreadcrumbTab[];
  supportEnabled?: boolean;
  username?: string;
  email?: string;
  docsUrl?: string;
  className?: string;
}

export function BreadcrumbHeader({
  pathname,
  breadcrumbs,
  supportEnabled,
  username,
  email,
  docsUrl,
  className,
}: BreadcrumbHeaderProps) {
  function openDocs() {
    window.open(docsUrl, "_blank");
  }

  const hasSupport = supportEnabled;

  return (
    <div
      className={cn(
        "flex items-center justify-between rounded-2 border border-overlay-medium bg-overlay-light p-md shadow backdrop-blur-md",
        className,
      )}
    >
      <div className="flex items-center gap-sm">
        <Button IconLeft={<SidebarSimpleIcon />} variant="plain" />

        <BreadcrumbNavList breadcrumbs={breadcrumbs} pathname={pathname} />
      </div>

      <div className="flex items-center justify-end gap-sm">
        {hasSupport ? (
          <Tooltip title="Support" asChild>
            <div className="-mr-md">
              <SupportMenu userEmail={email || ""} userName={username || ""} />
            </div>
          </Tooltip>
        ) : null}

        {docsUrl ? (
          <Tooltip title="Documentation" asChild>
            <Button
              aria-label="documentation"
              className="hover:bg-transparent hover:text-brand-primary focus:bg-transparent focus:text-neutral-700"
              onPress={openDocs}
              variant="tertiary"
            >
              <FilesIcon className="size-lg" />
            </Button>
          </Tooltip>
        ) : null}
      </div>
    </div>
  );
}
